import { Routes, Route, Navigate, useSearchParams } from 'react-router-dom';
import PartnershipPresentation from './pages/PartnershipPresentation';

function App() {
  return (
    <Routes>
      <Route path="/" element={<PartnershipRedirect />} />
      <Route path="/:partnerId" element={<PartnershipPresentation />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

// Redirect root to partnership selection or show access instructions
function PartnershipRedirect() {
  const [searchParams] = useSearchParams();
  const id = searchParams.get('id');
  
  if (id) {
    return <Navigate to={`/${id}`} replace />;
  }
  
  // Show access instructions instead of redirecting to a specific partner
  return (
    <div className="h-screen w-screen flex items-center justify-center bg-gradient-to-br from-white via-secondary/15 to-primary/15">
      <div className="text-center max-w-2xl px-6">
        <div className="mb-8">
          <img 
            src="/uploads/Color logo - no background-favicon.svg" 
            alt="Allegory Logo" 
            className="w-32 h-32 mx-auto mb-6"
          />
        </div>
        <h1 className="text-4xl font-extrabold mb-4 text-foreground">
          Partnership Presentations
        </h1>
        <p className="text-xl text-muted-foreground mb-8">
          Please use the specific partnership link provided to you.
        </p>
        <div className="bg-white/60 backdrop-blur-sm border border-primary/20 rounded-2xl p-6 text-left">
          <p className="text-sm text-muted-foreground mb-2">Example URL format:</p>
          <code className="text-primary font-mono text-sm">
            partnerships.allegory.world/[your-partnership]
          </code>
        </div>
      </div>
    </div>
  );
}

export default App;

